import * as React from 'react';
import { memo } from 'react';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { useResourceContext, useTranslate } from 'ra-core';
export var ListNoResults = memo(function () {
    var translate = useTranslate();
    var resource = useResourceContext();
    return (React.createElement(CardContent, null,
        React.createElement(Typography, { variant: "body2" }, translate('ra.navigation.no_results', { resource: resource }))));
});
//# sourceMappingURL=ListNoResults.js.map